module.exports = __webpack_public_path__ + "img/wu.79638657.png";